const AUTH_PATHS = new Set(['/login', '/login-complete', '/invitation', '/auth-action']);
const SECRET_PARAMETERS = ['invitationToken', 'registrationToken', 'oobCode', 'verifyCode'];
const URL_PROPERTIES = ['$current_url', '$referrer', '$initial_current_url', '$initial_referrer'];

export function redactAuthUrl(raw: string): string {
  try {
    const url = new URL(raw);
    if (AUTH_PATHS.has(url.pathname)) {
      url.search = '';
      url.hash = '';
    } else {
      for (const name of SECRET_PARAMETERS) url.searchParams.delete(name);
    }
    return url.toString();
  } catch {
    return raw;
  }
}

/** PostHog adds URL properties even to events whose explicit payload only contains a provider. */
export function sanitizeAuthEventProperties(
  properties: Record<string, unknown>,
): Record<string, unknown> {
  const result = { ...properties };
  for (const name of SECRET_PARAMETERS) delete result[name];
  for (const name of URL_PROPERTIES) {
    if (typeof result[name] === 'string') result[name] = redactAuthUrl(result[name]);
  }
  for (const name of ['$set', '$set_once']) {
    const value = result[name];
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      result[name] = sanitizeAuthEventProperties(value as Record<string, unknown>);
    }
  }
  return result;
}
